import { development } from 'app/config/constants'
import UnavailableSvg from 'assets/unavailable.svg'
import { clsx } from 'clsx'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { postMessage } from 'util/message'
import css from './UnavailablePage.module.scss'

type Props = {
  error?: string
}

export const UnavailablePage = observer(({ error }: Props) => {
  const onRefresh = useLatestCallback(() => {
    if (development) location.reload()
    if (error) store.state = 'none'
    else postMessage('refresh')
  })

  if (store.state !== 'max') return null

  if (opt.stand) return <Vertical className={css.page} gap={48} tall wide center>
    <UnavailableSvg style={{ width: 192, height: 'auto' }} />
    <Vertical gap={8}>
      <Typo size={32} semi center>
        {error || i18n('TheServiceIsTemporarilyUnavailable')}
      </Typo>
      <Typo size={24} secondary center>
        {i18n('PleaseTryAgainLater')}
      </Typo>
    </Vertical>
    <Space className={clsx(css.button, css.large)} onClick={onRefresh}>
      <Icon size={28} name="autorenew" />
      <Typo size={24} semi>
        {error ? i18n('Close') : i18n('Refresh')}
      </Typo>
    </Space>
  </Vertical>

  return <Vertical className={css.page} gap={32} tall wide center>
    <UnavailableSvg style={{ width: 128, height: 'auto' }} />
    <Vertical gap={8}>
      <Typo size={13} medium center>
        {error || i18n('TheServiceIsTemporarilyUnavailable')}
      </Typo>
      <Typo size={13} secondary center>
        {i18n('PleaseTryAgainLater')}
      </Typo>
    </Vertical>
    <Space className={clsx(css.button, css.small)} onClick={onRefresh}>
      <Icon size={16} name="autorenew" />
      <Typo size={13} medium>
        {error ? i18n('Close') : i18n('Refresh')}
      </Typo>
    </Space>
  </Vertical>
})
